export function initNumbers() {
  const numbers = document.querySelectorAll('.number-item');

  if (!numbers.length) {
    return false;
  }

  numbers.forEach((number) => {
    const span = number.querySelector('.number-item__number');
    const text = span.textContent || '';

    // Nur Ziffern zählen (alles außer 0–9 entfernen)
    const digitsOnly = text.replace(/\D+/g, '');
    const digitCount = digitsOnly.length;

    if (digitCount > 0) {
      number.classList.add(`number-item__digits-${digitCount}`);
    }
  });

  // Kein Cleanup notwendig
  return false;
}

